module.exports = __webpack_public_path__ + "img/重庆交通大学.70be014d.png";